<template>
  <a-modal
    v-model="visible"
    class="rename-modal"
    :centered="true"
    title="重命名"
    width="560px"
    :maskClosable="false"
    @cancel="cancelSave"
  >
    <div class="rename-modal__content">
      <span class="label">元素名称：</span>
      <a-input
        v-model="effectName"
        @pressEnter="renameSave"
        :placeholder="placeholder"
      />
    </div>
    <template slot="footer">
      <a-button @click="cancelSave">取消</a-button>
      <a-button @click="renameSave" type="primary">确定</a-button>
    </template>
  </a-modal>
</template>
<script>
import { mapState } from 'vuex';

export default {
  data() {
    return {
      effectName: ''
    };
  },
  computed: {
    ...mapState(['shapeNames']),
    visible: {
      get() {
        return this.$store.state.renameVisible;
      },
      set(value) {
        this.$store.commit('handleRenameVisible', value);
      }
    },
    renameId() {
      return this.$store.state.renameId;
    },
    placeholder() {
      const effect = this.$store.state.effects[this.renameId];
      return effect && (effect.type === 'text' || effect.type === 'textContainer' || effect.type === 'wordArt') ? '默认使用文本内容' : '请输入名称'
    }
  },
  methods: {
    cancelSave() {
      this.visible = false;
    },
    renameSave() {
      const effect = this.$store.state.effects[this.renameId];
      if (!this.effectName && effect.type !== 'text' && effect.type !== 'textContainer' && effect.type !== 'wordArt') {
        this.$message.error('元素名称不能为空');
        return;
      }
      effect.content.name = this.effectName;
      this.visible = false;
    }
  },
  watch: {
    visible() {
      if (this.visible) {
        const effect = this.$store.state.effects[this.renameId];
        const efc = effect.content;
        if (efc.name) {
          this.effectName = efc.name;
        } else {
          switch (effect.type) {
            case 'text':
            case 'textContainer':
            case 'wordArt':
              this.effectName = efc.text;
              break;
            case 'shape':
            case 'container':
              this.effectName = this.shapeNames[efc.shape];
          }
        }
      }
    }
  }
}
</script>

<style scoped>
.rename-modal__content {
  display: flex;
  align-items: center;
}
.rename-modal__content .label {
  flex-shrink: 0;
}
</style>
